import {
  ContentSection as HygraphContentSectionProps,
  Maybe as HygraphMaybe,
} from '@/lib/types';

import { ContentSectionProps } from '@/components/content-section';

import horizontalAlignmentTransformer from '@/hygraph/transformers/horizontal-alignment.transformer';
import linkTransformer from '@/hygraph/transformers/link.transformer';
import richTextTransformer from '@/hygraph/transformers/rich-text.transformer';

export default function contentSectionTransformer(
  hygraphProps: HygraphMaybe<HygraphContentSectionProps> | undefined
) {
  if (!hygraphProps) {
    return undefined;
  }
  return {
    align: horizontalAlignmentTransformer(hygraphProps.alignment),
    caption: hygraphProps.caption || undefined,
    title: hygraphProps.title || undefined,
    body: richTextTransformer({
      content: hygraphProps.body?.raw,
    }),
    useCheckmarkForLIs: hygraphProps.useCheckmarkForLIs || false,
    link: linkTransformer(hygraphProps.link),
  } as ContentSectionProps;
}
